// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import ConversationsList from 'syft-acp-core/entities/ConversationsList'
import PageTitle from 'syft-acp-core/components/PageTitle'

export const WatchlistConversationsList = () => (
  <PageTitle title={['Worker conversations', 'Watchlist']}>
    <ConversationsList />
  </PageTitle>
)
